// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"93":"2316eef4","409":"c1c94c31","704":"18992cb3"}[chunkId] + ".css";
};